import { SectionData } from "../shared/types";

export const sectionData: SectionData[] = [
  {
    section: "DISS",
    url: "dissipatio",
    logo: "logoDiss",
    bg: "#fce018",
    bgPrev: "#7e00e4",
    title: "Dissipatio",
    desc: "Una cellula mediatica",
    longDesc:
      "Dissipatio è una cellula mediatica, fondata nel 2022 e diretta da Sebastiano Caputo, che si muove nello spaziotempo attraverso la produzione di approfondimenti, analisi e scenari strettamente collegati all'attualità quanto alle meccaniche dello spirito della nostra epoca.",
    sideDesc:
      "Dissipatio è una cellula mediatica di cabotaggio e sabotaggio; di relazioni umane e di affari strategici, con oltre 60 collaboratori coordinati da Andrea Muratore.",
    numbers: [
      {
        amount: "2K",
        desc: "Follower su facebook",
      },
      {
        amount: "11K",
        desc: "Follower su Twiter",
      },
      {
        amount: "2K",
        desc: "Follower su instagram",
      },
      {
        amount: "+3K",
        desc: "Utenti unici al giorno",
      },
      {
        amount: "3",
        desc: "Longform al giorno",
      },
    ],
    outro: '"Sciameranno da ogni declivio"',
    link: "https://www.dissipatio.it/",
    cover: "coverDiss",
  },
  {
    section: "PNG",
    url: "pangea",
    logo: "logoPangea",
    bg: "#931313",
    bgPrev: "#fce018",
    title: "Pangea",
    desc: "Rivista avventuriera di cultura e idee",
    longDesc:
      "Una rivista avventuriera di cultura e idee, fondata nel 2016 e diretta da Davide Brullo, che pubblica quotidianamente repêchage, testi introvabili, stroncature, ritratti, manoscritti e autori, inattuali. ",
    sideDesc:
      "Dissipatio è una cellula mediatica di cabotaggio e sabotaggio; di relazioni umane e di affari strategici, con oltre 60 collaboratori coordinati da Andrea Muratore.",
    numbers: [
      {
        amount: "25K",
        desc: "Follower su facebook",
      },
      {
        amount: "2K",
        desc: "Follower su instagram",
      },
      {
        amount: "+7K",
        desc: "Utenti unici al giorno",
      },
      {
        amount: "3",
        desc: "Longform al giorno",
      },
    ],
    outro:
      '"Manderò un fuoco su Magog e sopra quelli</br> che abitano in pace"',
    link: "https://www.pangea.news/",
    cover: "coverPangea",
  },
  {
    section: "BLST",
    url: "blast",
    logo: "logoBlast",
    bg: "#ff32b9",
    bgPrev: "#931313",
    title: "Blast",
    desc: "Un blog/zine cyberpunk e accelereazionario",
    longDesc:
      "Un blog cyberpunk e dadaista, fondato nel gennaio 2022 e diretto nell'anonimato da un collettivo di ragazze e ragazzi nati nel 2000, che attraverso la scrittura creativa e visiva, esplora nuovi linguaggi, e affronta temi virali, di tendenza, di agitazione.  ",
    sideDesc: "",
    numbers: [
      {
        amount: "125K",
        desc: "Follower su facebook",
      },
      {
        amount: "20K",
        desc: "Follower su instagram",
      },
      {
        amount: "+3K",
        desc: "Utenti unici al giorno",
      },
      {
        amount: "1",
        desc: "Longform al giorno",
      },
    ],
    outro: '"Così non poterono scalarlo neppure </br> aprirvi un varco"',
    link: "https://www.ilblast.it/",
    cover: "coverBlast",
  },
  {
    section: "BLBREP",
    url: "bubble-report",
    logo: "logoBubble",
    bg: "#575757",
    bgPrev: "#ff32b9",
    title: "Bubble Report",
    desc: "A revolution will never be possible in Brussels, because we all know each other",
    longDesc:
      "In grey Brussels, some bubbles also sparkle. Bureaucracy and champagne flutes produce a unique music that sounds like the chatter in the corridors, the whispering in the right ears. Brussels is a bubble and the people working in the European institutions, from the accredited parliamentary assistants to the Commissioner, they all live inside a collective dream whose rules and principles are often unknown to the general public. This is exactly why Bubble Report was created: to narrate this bubble from the inside, to record the whispering which is, at the end of the day, all that matters.",
    sideDesc: " ",
    numbers: [
      {
        amount: "125K",
        desc: "Follower su facebook",
      },
      {
        amount: "20K",
        desc: "Follower su instagram",
      },
      {
        amount: "+3K",
        desc: "Utenti unici al giorno",
      },
      {
        amount: "1",
        desc: "Longform al giorno",
      },
    ],
    outro:
      "Alla fine dei giorni io ti manderò sulla mia terra perché le nazioni mi conoscano quando per mezzo tuo, o Gog, manifesterò la mia santità davanti ai loro occhi",
    link: "https://bubblereport.eu/",
    cover: "coverBubble",
  },
  {
    section: "BYRM",
    url: "bayram",
    logo: "logoBy",
    bg: "#52FFA4",
    bgPrev: "#575757",
    title: "Bayram",
    desc: "Il tempo della cosmopolitica",
    longDesc:
      "Bayram - Il tempo della cosmopolitica, è una rassegna culturale l'obiettivo di creare una piattaforma (e una sfida) generazionale di profondissima visione che possa diventare nel tempo il punto di congiunzione e di passaggio della classe dirigente di ieri, di oggi e soprattutto di domani.  La prima edizione, con il supporto di istituzioni pubbliche e sponsor privati, si è svolta sabato 4 ottobre 2025 dalle ore 10 alle 21 al Maxxi di Roma - Museo delle arti del ventunesimo secolo, coinvolgendo 80 ospiti, di cui il 62% under 42, che si sono alternati tra presentazioni di libri, monologhi sul palco e dibattiti tematici e che ha visto la partecipazione di oltre 2mila persone in presenza.",
    sideDesc: "",
    numbers: [
      {
        amount: "2260",
        desc: "Partecipanti al panel",
      },
      {
        amount: "1500",
        desc: "Partecipanti singoli",
      },
      {
        amount: "72",
        desc: "Ospiti",
      },
      {
        amount: "20",
        desc: "Ore di permanenza per numero di panel",
      },
      {
        amount: "6",
        desc: "Ore di permanenza media",
      },
    ],
    outro: "",
    link: "https://bayramcosmopolitica.it/",
    cover: "coverBayram",
  },
];
